import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./featured-title.${locale}.json`));
